module.exports = __webpack_public_path__ + "img/local-21.d66fa64a.jpg";